<template>
    <div v-if="info !== null" class="wolt-warning" :style="{ backgroundColor: background, borderColor: color, color: color}">
        <div class="left">
            <div class="img-div">
                <img src="/img/icons/wolt-logo.svg" :alt="woltIconAlt">
            </div>
        </div>
        <div>
            {{ info }}
        </div>
    </div>
</template>

<script>
import {reactive, toRefs, onMounted} from 'vue'
import axios from "axios";

export default {

    props: [
        'woltIconAlt'
    ],

    setup(props) {

        const state = reactive({
            info: null,
            background: '#00c2e80d',
            color: '#00C2E8',
        })

        onMounted( () => {
            getWoltInfo()
        })

        function getWoltInfo() {
            axios.post('/api/get-wolt-info-block', {}
            ).then( response => {
                state.info = null
                if (response.data.info_data) {
                    state.info = response.data.info_data.message
                    state.background = response.data.info_data.background
                    state.color = response.data.info_data.color
                }
            }).catch( error => flash(error.message, 'danger'))
        }

        return {
            ...toRefs(state),
        }
    }
}
</script>
